/* uses insta-tokens which returns the long term token needed for the instagram API */
var tokenURL = "https://ig.instant-tokens.com/users/d6247f82-cac0-417e-8177-2272ec96a453/instagram/17841423279074536/token?userSecret=mbuc67qtdplyey2qgtko0c"

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.hFac = "1"
lazySizesConfig.expand = 200

axios.get(tokenURL)
  .then(function (response) {
    // handle success
    if (response.data.Token) {
      instagramFeedHandler(response.data.Token);
    }
  })
  .catch(function (error) {
    // handle error
    console.log(error);
  })
  .then(function () {
    // always executed
  });

function renderSwiper() {
  var mySwiper = new Swiper('.js-instagram-feed', {
    // Optional parameters
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 50,
    grabCursor: true,
    breakpoints: {
      // remove space between slides when not on mobile
      600: {
        spaceBetween: 0,
      },
    },
  })
}

function instagramFeedHandler(token) {
  var feed = new Instafeed({
    target: 'js-instagram',
    accessToken: token,
    templateBoundaries: ['<%','%>'],
    template: '<div class="instagram-feed__item swiper-slide"><a href="<% link %>" target="_blank" class="instagram-feed__image"><img title="<% caption %>" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-src="<% image %>" class="lazyload instagram-feed__canvas" /></a></div>',
    after: function() {
      renderSwiper()
    },
    transform: function(item) {
      return item;
    },
  });
  feed.run();
}

console.log('yes')